// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2XJIm","amount":"Amount_amount__16cnT","tip":"Amount_tip__2PmZv","tipHeader":"Amount_tipHeader__vU2dZ","tipsWrap":"Amount_tipsWrap__24TLJ"};